"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Colors = void 0;
var Colors = {
  primary: '#5AC0FC',
  light: '#FFF',
  dark: '#000',
  cultured: '#F9FAFC',
  darkCultured: '#F3F3F3',
  silver: '#c4c4c4',
  darkSilver: '#757575',
  platinum: '#e6e6e6',
  purple: '#6C63FF',
  maxBluePurple: '#B5B1FF',
  independence: '#3f3d56',
  spanishGray: '#979797',
  princetonOrange: '#FF8532',
  lavender: '#F0EFFF',
  yellow: '#ffdd6d',
  orange: '#F55F44',
  red: '#dc3545',
  purpleNavy: '#575A89',
  green: '#00d66b',
  lightRed: '#ff3100'
};
exports.Colors = Colors;